export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-120x120-a6ce7ad128f3ed7a9356e77f93df5e74.png";